<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <section>
        <!-- <div class="materials_logo"><img style="width:85%" :src="datas.business.logo"></div> -->

        <!-- 焦点图 -->
        <div class="MainBox" v-if="datas.focus && datas.focus_pics_is_show == 1">
          <div class="swiper-container materials_banner">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in datas.focus" v-bind:key="index"><img style="width:100%"
                  :src="item.img"></div>
            </div>
          </div>
        </div>

        <div class="materials_nav">
          <p>
            <a v-for="(item, index) in nav" v-text="item.value" :class="{ 'materials_nav_active': item.active }"
              v-on:click="navSwitch(index)"></a>
          </p>
        </div>

        <!-- 查询容器 -->
        <section class="query-box" v-if="nav[0].active">
          <div class="queryBox_two" style="border:2px solid #F2621C;">
            <a><input v-model="vcode" @keyup.enter="CodeVerify" class="SecurityCode" placeholder="请输入您的验证码查询"
                type="text"></a>
            <a class="queryButton" v-on:click="CodeVerify" style="background-color: #F2621C;"><img width="35px"
                src="../../static/images/query.png"></a>
          </div>

          <div class="dcBox" v-if="isShow">
            <div class="bottom_con">
              <div class="dc_title">查询结果</div>
              <ul class="dc_productDetails">
                <li style="margin-bottom:10px;"><img width="100%" :src="datas.product.img" :alt="datas.product.img">
                </li>
                <li>
                  <p>被查次数：{{ datas.query_count }}次</p>
                  <p>首次被查时间：{{ datas.query_first_time }}</p>
                  <p v-if="datas.product.introduce">产品介绍：{{ datas.product.introduce }}</p>
                </li>
              </ul>
              <div class="ValidationTips" v-if="datas.query_count <= 1">
                <div v-if="datas.first_antifake_msg" v-text="datas.first_antifake_msg"></div>
                <div v-else>系统提示：恭喜你，您输入的防伪码正确有效，您所查询的产品为<a style="color:#f00"
                    v-text="datas.business.name"></a>生产的正牌产品，感谢查询！</div>
              </div>
              <div class="ValidationTips" v-else style="color:#f00">
                <p v-if="datas.many_antifake_msg" v-text="datas.many_antifake_msg"></p>
                <p v-else>您所查询的二维码已经多次查询，谨防假冒！</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 企业信息 -->
        <section class="query-result-box" v-else>

          <!-- 相关推荐 -->
          <div v-if="datas.ref && datas.ref_is_show == 1">
            <div v-for="(item, index) in datas.ref" v-bind:key="index">
              <div class="materials_title">
                <a></a>
                <a v-text="item.name"></a>
              </div>
              <div v-for="(val, ix) in item.datas" v-bind:key="ix">
                <p class="MainRefDatasTxt" v-if="val.type == 0" v-text="val.data"></p>
                <img class="img-box" v-else :src="val.data">
              </div>
            </div>
          </div>

          <!-- 企业资料 -->
          <div v-if="datas.business.customize_data">
            <div v-for="val in datas.business.customize_data">
              <div
                v-if='val.value && (val.value.substring(val.value.length - 3) == "jpg" || val.value.substring(val.value.length - 3) == "png")'>
                <img class="img-box" :src="val.value" />
              </div>
              <div v-else>{{ val.key + ":" + val.value }}</div>
            </div>
          </div>
          <div class="materials_text" v-html="datas.business.intro"></div>

        </section>

        <!-- 自定义导航 -->
        <div class="bottomNav_one default_footMenu" style="border-top:none;background-color:#FFFFFF;margin-top:10px;"
          v-if="datas.menu && datas.menu_is_show == 1">
          <ul style="border-bottom:1px solid #e3e3e3" v-for="(item, index) in datas.menu" v-bind:key="index">
            <a>
              <li style="background-color: #FFF;" v-if="item.icon"><img style="width:80%;margin:0px auto;"
                  :src="item.icon"></li>
              <li style="background-color: #FFF;">
                <p style="color:#000" v-text="item.name"></p>
                <p style="color:#555" v-text="item.describe"></p>
              </li>
            </a>
          </ul>
        </div>


        <div class="materials_phone" v-if="datas.business.linkphone">客服联系热线：{{ datas.business.linkphone }}</div>

      </section>

      <!-- 提示框 -->
      <section id="MaskedBlock" v-if="hintTxt">
        <i class="Masked"></i>
        <div class="ToolTip">
          <ul>
            <li>{{ datas.business.name }}</li>
            <li class="MaskedMain" v-text="hintTxt"></li>
            <li class="confirm" v-on:click="CloseTip">确定</li>
          </ul>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
import { getUserLocation } from '../hook/common.js'
export default {
  name: 'AntiFake07',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      datas: null,
      msg: null,
      locations: {},
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      hintTxt: '',
      isShow: false,
      vcode: '',
      nav: [{
        active: true,
        value: "防伪查询"
      }, {
        active: false,
        value: "公司介绍"
      }]
    }
  },
  created() {
    document.querySelector('body').setAttribute('style', 'background-color:rgb(243, 243, 243)');
    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      this.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      this.code = this.GetCode();
      this.GetDatas();  //获取码标信息
    }
  },
  updated() {
    new Swiper('.materials_banner', {
      autoplay: 3000,//可选选项，自动滑动
      pagination: '.swiper-pagination',
      autoHeight: true, //高度随内容变化
      paginationType: 'progress',
      loop: true,
    })
  },
  methods: {
    async getLocation (){
      await this.getWXInfo()
      const res = await getUserLocation();
      let position = {};
      if (res.code == 200) {
        position = {
          address: res.data.detail.address,
          country: res.data.detail.addressComponents.country, //国家
          province: res.data.detail.addressComponents.province, //省
          city: res.data.detail.addressComponents.city, //市
          district: res.data.detail.addressComponents.district, //区
          location: res.data.detail.location.lng+','+res.data.detail.location.lat //经纬度
        }
      }
      return position;
    },
    getSignUrl() {
      var signLink = ''
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        signLink = `https://lj.oid.plus/?${this.code}`;
      } else {
        signLink = location.href
      }
      return signLink;
    },
    getWXInfo: function () {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "post",
          url: "https://sale.oid.plus/v1/wechat-public/js-ticket",
          dataType: 'json',
          data: {
            url: this.getSignUrl(),
            syid: "100010034"
          },
          success: function (res) {
            if (res.code == 200) {
              resolve(true);
              wx.config({
                // debug: true,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
                jsApiList: ['scanQRCode', "getLocation"]
              });
            } else {
              resolve(false);
            }
          },
          error: function (err) {
            resolve(false);
          }
        });
      })
    },
    GetDemoDatas(pid, rid) {
      axios.get(this.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then((response) => {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
          console.log(datas)
          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }
          this.datas = datas;

          // document.title = this.datas.business.name;  //设置页面标题
        }).catch((error) => {
          console.log(error)
          this.Loading.type = 3;
          this.Loading.txt = this.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(this.GetServerUrl(1) + "query/" + this.code)
        .then((response) => {

          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          this.msg = "你所查询的是 " + datas.business.name + " 产品"
          if (datas.first_antifake_msg) {
            this.msg = datas.first_antifake_msg;
          }

          //空格、回车
          if (datas.business.intro != null) {
            datas.business.intro = datas.business.intro.replace(/\n/g, "</br>").replace(/ /g, "&nbsp;");
          }

          //针对某企业设置
          if (datas.scan_count > 1 && datas.business.rootid == "100010028") {
            datas.scan_count--
          }

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);

            if (datas.business.customize_data) {
              for (let i in datas.business.customize_data) {
                if (datas.business.customize_data[i].key == "经纬度") {
                  this.location = datas.business.customize_data[i].value;
                }
              }
            }

          }
          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          this.datas = datas;

          //温州中安防伪技术有限公司
          if (datas.business.rootid === '100010143') {
            document.title = '防伪溯源平台';  //设置页面标题
          } else {
            // document.title = this.datas.business.name;  //设置页面标题
          }

          //地图定位，获取地址信息后新增扫码记录
          if(datas.location_type === 1){
            this.addQueryRecord();
          }

        }).catch((error) => {
          console.log(error)
          this.Loading.type = 3;
          this.Loading.txt = this.ErrorHint(error);
        })
    },
    CodeVerify() {
      this.isShow = false;
      axios.get(this.GetServerUrl(1) + "queryVerify/" + this.code + "/" + this.vcode)
        .then((response) => {
          var json = response.data;
          if (json.code == 200) {
            this.isShow = true;
            this.datas.query_count = response.data.meta.query_count;  //查询次数
            this.datas.query_first_time = response.data.meta.query_first_time;  //查询时间
            this.datas.query_first_address = response.data.meta.query_first_address;  //查询地点
          } else {
            this.hintTxt = "防伪码不正确，谨防假冒！";
          }
        }).catch((error) => {
          this.hintTxt = "防伪码不正确，谨防假冒！";
          console.log(error)
        })
    },
    async addQueryRecord() {
      const data = await this.getLocation();
      const params = {
        type: 1, //0-ip,1-定位
        code: this.code,
        province: data.province || '', //省
        city: data.city || '', //市
        district: data.district || '', //区
        address: data.address || '', //详细地址
        company_id: this.datas.business.rootid, //企业id
        product_name: this.datas.product.name, //产品名称
        location: data.location || '', //经纬度
      }
      axios.post(this.GetServerUrl(1) + "addQueryRecord",params);
    },
    CloseTip() {
      this.hintTxt = null;
    },
    navSwitch(ix) {
      for (let i in this.nav) {
        this.nav[i].active = false;
      }
      this.nav[ix].active = true;
    }
  }
}
</script>

<style scoped>
section {
  font-size: 16px;
}

/* 建材  */
.materials_logo {
  overflow: hidden;
  background-color: #FFFFFF;
  text-align: center;
  font-size: 1.5em;
}

.materials_logo img {
  display: block;
  width: 70%;
  margin: 15px auto;
}

.materials_swiper img {
  display: block;
  width: 100%;
}

.materials_nav {
  overflow: hidden;
  margin-bottom: 10px;
  background-color: #FFFFFF;
}

.materials_nav p {
  width: 180px;
  overflow: hidden;
  margin: 10px auto;
}

.materials_nav a {
  display: block;
  width: 90px;
  float: left;
  text-align: center;
  padding: 9px 0px;
  color: #FFFFFF;
  background-color: #c9c9c9;
}

.materials_nav a:first-child {
  border-radius: 5px 0px 0px 5px;
}

.materials_nav a:last-child {
  border-radius: 0px 5px 5px 0px;
}

.materials_nav_active {
  background-color: #f2621c !important;
}

.materialsBox {
  background-color: #FFFFFF;
  padding: 0px 8px;
}

.materials_title {
  overflow: hidden;
  padding: 10px 0;
}

.materials_title a {
  display: block;
  float: left;
  color: #F2621C;
  line-height: 20px;
}

.materials_title a:first-child {
  height: 20px;
  width: 5px;
  margin-right: 8px;
  border-radius: 5px;
  background-color: #F2621C;
}

.materials_text {
  padding: 8px 0px;
  line-height: 25px;
  color: #333;
  font-size: 0.95em;
}

.materials_qr {
  margin-top: 8px;
  overflow: hidden;
  padding: 15px 0px;
  background-color: #FFFFFF;
}

.materials_qr p:last-child {
  margin-top: 12px;
}

.materials_qr img {
  display: block;
  width: 50%;
  margin: 0px auto;
}

.materials_phone {
  padding: 12px 0px;
  text-align: center;
  color: #fff;
  margin-top: 8px;
  background-color: #F2621C;
}


.materialsBox,
.query-result-box {
  padding: 10px 12px;
  background-color: #FFFFFF;
}

.dc_title {
  background-color: #EEEEEE;
  padding: 10px 10px;
  margin-bottom: 10px;
  border-radius: 3px 3px 0 0;
}

.dc_productDetails {
  padding: 0px 10px;
}

.dc_productDetails p {
  line-height: 26px;
  color: #333;
  padding-bottom: 5px;
}

.ValidationTips {
  padding: 10px 0px;
  margin: 0px 10px;
  color: #327fd2;
  font-size: 1.3em;
}

.bottom_con {
  margin: 0px auto;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 3px;
  box-shadow: 2px 2px 5px rgba(9, 9, 9, .2);
}

.query-box {
  padding: 10px;
  background-color: #FFF;
}

.confirm {
  background-color: #f2621c !important;
}</style>



// WEBPACK FOOTER //
// src/view/AntiFake07.vue